import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef
} from "@angular/core";
import {SessionActions} from "../../../shared/actions/session.actions";
import {ApolloQueryObservable} from "apollo-angular";
import {ApolloQueryResult} from "apollo-client";
import {select} from "@angular-redux/store";
import {Observable} from "rxjs/Observable";
import {IUser} from "../../../shared/redux-store/session/session.types";
import {GenericModalComponent} from "../ui/forms/generic-modal/generic-modal.component";
import {VisBosComponent} from "../../../visbos.component";
import {ActionBarAction} from "../ui/navigation/action-bar/action-bar.component";
import {AdministrationUnit} from "../../../shared/view-model/organization/administration-unit.type";
import {FormArray, FormGroup} from "@angular/forms";
import {Subscription} from "rxjs/Subscription";

/**
 * Created by afuhr on 24.02.2017.
 */

function isApolloQueryResult(object: any): object is ApolloQueryResult<any> {
  return (<ApolloQueryResult<any>>object) !== undefined;
}

export abstract class AbstractVisbosComponent implements OnInit, AfterViewInit, OnDestroy {

  public initialized = false;

  actions: ActionBarAction[];

  @Input()
  isTouch: boolean = false;

  @select(['session', 'activeAdminUnit'])
  activeAdminUnitCuid$: Observable<string>;
  activeAdminUnitCuid: string;

  @select(['session', 'activeAdminUnitData'])
  activeAdminUnit$: Observable<AdministrationUnit>;
  activeAdminUnit: AdministrationUnit;

  @select(['session', 'user'])
  currentUser$: Observable<IUser>;
  currentUser: IUser;

  loadingIndicators: Map<string, boolean> = new Map();
  isLoading: boolean = false;

  protected dataSubscriptions: Subscription[] = [];

  protected dataObservables: ApolloQueryObservable<any>[] = [];

  constructor(protected sessionActions: SessionActions, protected cd: ChangeDetectorRef) {
    this.actions = [];

    this.dataSubscriptions.push(this.currentUser$.subscribe(user => {
      this.currentUser = user;
      if (this.cd && this.initialized) {
        //this.cd.detectChanges();
      }
    }));
    this.dataSubscriptions.push(this.activeAdminUnitCuid$.subscribe(au => {
      this.activeAdminUnitCuid = au;
      if (this.cd && this.initialized) {
        //this.cd.detectChanges();
      }
    }));
    this.dataSubscriptions.push(this.activeAdminUnit$.subscribe(au => {
      this.activeAdminUnit = au;
      if (this.cd && this.initialized) {
        //this.cd.detectChanges();
      }
    }));

  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.initialized = true;
  }

  ngOnDestroy(): void {
    this.initialized = false;
    //TODO: reactivate when apollo solves problem of failing refetches on unsubscribing from queries
    this.dataSubscriptions.forEach(sub => {
      //if (!(sub instanceof ApolloQueryObservable)) {
      if (sub && sub instanceof Subscription) {
        sub.unsubscribe();
      }
      //}
    });
  }

  addComponentData(data: ApolloQueryObservable<any>) {
    this.dataObservables.push(data);

    if (!this.actions.find(a => a.label == 'Daten neu laden')) {
      this.actions = [{
        label: 'Daten neu laden',
        icon: 'fa-sync',
        action: () => this.reloadData.apply(this)
      }, ...this.actions];
    }

  }

  addSubscription(sub: Subscription) {
    this.dataSubscriptions.push(sub);
  }

  getComponentData(): ApolloQueryObservable<any>[] {
    return this.dataObservables;
  }

  reloadData() {
    this.sessionActions.initAsyncAction();
    let id = 0;
    this.dataObservables.forEach(obs => {
      if (obs) {
        this.loadingIndicators.set('Q' + id, true);
        obs.refetch().then(res => {
          this.loadingIndicators.set('Q' + id, false);
          if (!this.isDataLoading()) {
            this.sessionActions.finishAsyncAction();
          }
        });
      }
    }, id);
  }

  isDataLoading(): boolean {
    let result = false;
    this.loadingIndicators.forEach((value, key) => {
      result = result || value;
    });
    return result;
  }

  resetComponent(): void {
    this.initialized = false;
    this.cd.detectChanges();
    this.initialized = true;
    this.cd.detectChanges();
  }

  /*protected createDynamicComponent(data: { component: any, inputs: any }, dynamicComponentContainer: ViewContainerRef, resolver: ComponentFactoryResolver) {

    if (!data) {
      return;
    }

    // Inputs need to be in the following format to be resolved properly
    let inputProviders = Object.keys(data.inputs).map((inputName) => {
      return {provide: inputName, useValue: data.inputs[inputName]};
    });
    let resolvedInputs = StaticInjector.create(inputProviders);

    // We create an injector out of the data we want to pass down and this components injector
    let injector = StaticInjector.fromResolvedProviders(resolvedInputs, dynamicComponentContainer.parentInjector);

    // We create a factory out of the component we want to create
    let factory = resolver.resolveComponentFactory(data.component);

    // We create the component using the factory and the injector
    let component = factory.create(injector);

    // We insert the component into the dom container
    dynamicComponentContainer.insert(component.hostView);

    console.info("Cmp", [component]);

    return component;

  }*/

  protected destroyDynamicComponent(component) {
    if (component) {
      component.destroy();
    }
  }

  createModal(appRef: ApplicationRef, componentFactoryResolver: ComponentFactoryResolver, modalTemplate: TemplateRef<any>, modalComponent: { new(cd?): GenericModalComponent }): ComponentRef<GenericModalComponent> {

    let rootViewRef = (appRef.components[0].instance as VisBosComponent).rootViewRef;
    let modal: GenericModalComponent;

    rootViewRef.clear();

    let dialogComponentFactory =
      componentFactoryResolver.resolveComponentFactory(modalComponent);
    let dialogComponentRef = rootViewRef.createComponent(dialogComponentFactory);

    modal = dialogComponentRef.instance;

    modal.mainContentTmpl = modalTemplate;
    modal.closed.subscribe(() => {
      dialogComponentRef.destroy();
    });

    dialogComponentRef.changeDetectorRef.detectChanges();

    return dialogComponentRef;
  }

  getFormGroupById(formArray: FormArray, id: string | number, idPath = 'cuid'): FormGroup {
    return AbstractVisbosComponent.getFormGroupById(formArray, id, idPath);
  }

  static getFormGroupById(formArray: FormArray, id: string | number, idPath = 'cuid'): FormGroup {
    if (!formArray) {
      return undefined;
    }
    for (let ctrl of formArray.controls) {
      if (ctrl instanceof FormGroup && ctrl.get(idPath) && ctrl.get(idPath).value === id) {
        return ctrl;
      }
    }
    return undefined;
  }

  static getFormGroupIndexById(formArray: FormArray, id: string | number, idPath = 'cuid'): number {
    let index = 0;
    for (let ctrl of formArray.controls) {
      if (ctrl instanceof FormGroup && ctrl.get(idPath) && ctrl.get(idPath).value === id) {
        return index;
      }
      index++;
    }
    return -1;
  }

  public static convertTypeName(typeName: string): string {
    switch (typeName) {
      case "User":
        return "Benutzer";
      case "AdministrationUnit":
        return "Standort";
      default:
        return typeName;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/abstract-visbos.component.ts